import api from './api';

const adminService = {
  // Employees
  getEmployees: async (params = {}) => {
    try {
      const response = await api.get('/api/admin/employees', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createEmployee: async (payload) => {
    try {
      const response = await api.post('/api/admin/employees', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateEmployee: async (eid, payload) => {
    try {
      const response = await api.put(`/api/admin/employees/${eid}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteEmployee: async (eid) => {
    try {
      const response = await api.delete(`/api/admin/employees/${eid}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  setEmployeeBlock: async (eid, isBlocked) => {
    try {
      const response = await api.patch(`/api/admin/employees/${eid}/block`, { is_blocked: isBlocked });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Clients
  getClients: async (params = {}) => {
    try {
      const response = await api.get('/api/admin/clients', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  createClient: async (payload) => {
    try {
      const response = await api.post('/api/admin/clients', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateClient: async (clientId, payload) => {
    try {
      const response = await api.put(`/api/admin/clients/${clientId}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteClient: async (clientId) => {
    try {
      const response = await api.delete(`/api/admin/clients/${clientId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  setClientStatus: async (clientId, isActive) => {
    try {
      const response = await api.patch(`/api/admin/clients/${clientId}/status`, { is_active: isActive });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default adminService;
